
export default [
    {
        path: "/Approval/Index",
        name: "ApprovalIndex",
        component: () => import("@/components/Approval/Index.vue"),
        meta: {
            name: "ApprovalIndex",
            menuTitle: "Approval",
            requiresAuth: true
        },
        props: true
    },
    
   

    {
        path: "/Work/Index",
        name: "WorkIndex",
        component: () => import("@/components/Work/Index.vue"),
        meta:{
            name: "WorkIndex",
            menuTitle : "Work",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Work/Editor",
        name: "WorkEditor",
        component: () => import("@/components/Work/Editor.vue"),
        meta:{
            name: "WorkEditor",
            menuTitle : "Work",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Permit/Index",
        name: "PermitIndex",
        component: () => import("@/components/Permit/Index.vue"),
        meta:{
            name: "PermitIndex",
            menuTitle : "Permit",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Permit/Editor",
        name: "PermitEditor",
        component: () => import("@/components/Permit/Editor.vue"),
        meta:{
            name: "PermitEditor",
            menuTitle : "Permit",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/PermitChecklist/Index",
        name: "PermitChecklistIndex",
        component: () => import("@/components/PermitChecklist/Index.vue"),
        meta:{
            name: "PermitIndex",
            menuTitle : "Permit Checklist",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/PermitChecklist/Editor",
        name: "PermitChecklist",
        component: () => import("@/components/PermitChecklist/Editor.vue"),
        meta:{
            name: "PermitChecklistEditor",
            menuTitle : "Permit Checklist",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Report/Index",
        name: "Report",
        component: () => import("@/components/Report/Index.vue"),
        meta:{
            name: "ReportIndex",
            menuTitle : "Report",
            requiresAuth: true
        },
        props: true
    },
    
]